export interface KnowledgeCategory {
  name: string;
  children?: KnowledgeCategory[];
}

export interface KnowledgeContent {
  contentID: string;
  title: string;
  description: string;
  body?: string;
  image?: string;
  contentURL: string;
  imageURL?: string;
  externalStatus?: string;
  type?: string;
}

export interface EmergencyContent {
  contentID: string;
  title: string;
  description: string;
  excerpt: string;
  contentURL: string;
  imageURL?: string;
  externalStatus?: string;
  type?: string;
}

export interface Knowledge {
  isSearchByKeyboard: boolean;
  isContentSearching: boolean;
  faqBack: boolean;
  categorySelections: string[];
  categories: KnowledgeCategory[];
  contents: KnowledgeContent[];
  selectedContent: KnowledgeContent;
  selectedContentType: string;
  emergencyContents: EmergencyContent[];
}

export enum ContentType {
  timeline = 'soluto_timeline',
  emergency = 'emergency',
  faq = 'post'
}

export enum KnowledgeType {
  contractDevice = 'au端末',
  currentDevice = '現在ご利用の端末',
  faq = '困った・使い方がわからない',
  damage = '故障かも',
  physicalDamageOrLost = '破損・盗難・紛失',
  onboarding = '端末初期設定・データ移行',
  diagnoseDefect = '症状を選択して診断する',
  checkDefectSolutions = '症状の改善方法を調べる',
  nonCoverageDevice = 'それ以外の機器を調べる',
  initialSetup = '初期設定',
  dataMigration = 'データ移行',
  smartphoneTablet = 'スマートフォン・タブレット',
  unknown = '何を選択すればよいか分からない',
  kfs = 'KFS',
  otherPhone = 'その他のスマートフォン・タブレット'
}
